
class Details {
    [x: string]: any;
    static $inject = ['$location', 'AuthService', 'Users', 'Toast', '$state', 'AmplitudeService', 'Router'];
    constructor($location, AuthService, Users, Toast, $state, AmplitudeService, Router) {
        this.AuthService = AuthService;
        this.Users = Users;
        this.Toast = Toast;
        this.$state = $state;
        this.Amplitude = AmplitudeService;
        this.$location = $location;
        this.router = Router;
    }

    $onInit() {
        this.invitations = [{}];
        this.alreadyInvited = [];

        this.canEdit = this.AuthService.isOwner()
            ? true
            : this.user.role.toUpperCase() !== 'OWNER'
    }

    changeDontAcceptIncomingCalls() {
      this.Users.setBlockingIncomingCalls({id: this.user.id, block: this.user.doNotAcceptIncomingCalls}, {}, () => {
        this.Amplitude.logEvent('Do not disturb', {
          status: this.user.doNotAcceptIncomingCalls ? 'on' : 'off',
          source: 'user settings',
          by: this.AuthService.currentUser().username,
          to: this.user.username,
        });
        this.successMessage();
      });
    }

    changeMissedIncomingCallsNotification() {
      this.Users.changeMissedIncomingCallsNotification({id: this.user.id, enabled: this.user.missedIncomingCallsNotification, email: this.user.username}, {}, () => {
        this.Amplitude.logEvent('Missed incoming calls notification', {
          status: this.user.missedIncomingCallsNotification ? 'on' : 'off',
          source: 'user settings',
          by: this.AuthService.currentUser().username,
          to: this.user.username,
        });
        this.successMessage();
      });
    }

    successMessage() {
      this.Toast.success('CHANGES_SAVED');
      this.$state.reload();
    }

    editableUserIsOwner() {
      return this.user.role === 'Owner';
    }

    gotoAllUsers() {
      this.router.navigateByUrl('/users/all');
    }

    getState() {
      return this.state === 'all' ? undefined : this.state.toUpperCase();
    }

    goToUserEdit(){
      this.router.navigateByUrl(`/users/${this.state}/${this.userIndex}/edit`);
    }

}
export default {
    controller: Details,
    template : require('./users.details.html'),
    bindings: {user: '<', userIndex: '<', state: '<'}
};
